function rgbToHex(r: number, g: number, b: number) {
  const hex = (x: number) => Math.round(x).toString(16).padStart(2, '0');

  return `#${hex(r)}${hex(g)}${hex(b)}`;
}

export default rgbToHex;
